import React from 'react';
import {renderComponent} from '../dyanimcFormUtil.tsx';
import {FormComponentProps, LayoutGridComponent} from "../DynamicFormTypes.ts";

export const LayoutGridRenderer: React.FC<FormComponentProps<LayoutGridComponent>> = ({
                                                                                          component
                                                                                      }) => {
    const components = component.components || [];
    // Arrange components into rows based on their column width
    const rows = React.useMemo(() => {
        console.debug("LayoutGrid components: calculating rows", component.fieldKey);
        const out: typeof components[] = [];
        let current: typeof components = [];
        let width = 0;

        for (const comp of components) {
            const w = Math.min(12, Math.max(1, comp.width ?? 12));
            if (width + w > 12) {
                out.push(current);
                current = [comp];
                width = w;
            } else {
                current.push(comp);
                width += w;
            }
        }
        if (current.length) out.push(current);
        return out;
    }, [components]);

    const grid = React.useMemo(() => (
        <div className="space-y-1 w-full min-w-0">
            {rows.map((row, rowIndex) => (
                <div key={`layout-${component.componentId}-row-${rowIndex}`} className="grid grid-cols-12 gap-4 w-full min-w-0" >
                    {row.map((nested, colIndex) => {
                        // Calculate column classes
                        const width = nested.width || 12;
                        return (
                            <div
                                key={`layout-${component.componentId}-col-${rowIndex}-${colIndex}`}
                                style={{gridColumn: `span ${width} / span ${width}`}}
                                className="min-w-0 w-full h-min"
                            >
                                {renderComponent({
                                    component: nested,
                                })}
                            </div>
                        );

                    })}
                </div>
            ))}
        </div>
    ), [rows, component.fieldKey]);

    return (
        <div className="mb-4 w-full min-w-0">
            {component.showLabel &&
                <h3 className={`text-lg font-medium mb-2`}>
                    {component.label}
                </h3>
            }
            {grid}
        </div>
    );
}

export const LayoutGrid = React.memo(LayoutGridRenderer)